import React, { useState } from "react";
import CoursesFeatures from "../components/courses/CoursesFeatures";
import CustomSwitch from "../components/customers/CustomSwitch";
import GridCourses from "../components/home/GridCourses";
import { Grid } from "@material-ui/core";
import Navbar from "../components/global/Navbar";
import Footer from "../components/global/Footer";
import "../css/SingleCurso.css";
import CoursesHeader from "../components/courses/CoursesHeader";

const features = [
  "Incluye 3 disciplinas: Barre, Sculpt and Burn y Block Burn Pilates.",
  "Vive la experiencia de 3 días intensivos de certificación en vivo con nuestras Master Coaches.",
  "Complementa tu formación con 80 días de acceso a la plataforma on demand.",
  "Recibe correcciones y resuelve dudas en tiempo real.",
];

const LiveCourses = () => {
  const [location, setLocation] = useState("studio");

  return (
    <div className="bg-light overflow-x-hidden">
      <Navbar />
      <CoursesHeader />
      <div className="h-100">
        <Grid className="justify-content-center align-items-center">
          <div className="d-flex flex-column w-100">
            <Grid item xs={12} align="center" className="mt-4 mb-4">
              <CustomSwitch
                cursos={true}
                value={location}
                onChange={setLocation}
              />
            </Grid>
            <h1 className="h3 text-center">
              Certificación{" "}
              {location === "studio" ? "presencial" : "remota"}{" "}
            </h1>
            <div className="separator my-3"></div>
            {location !== "studio" && <p className="text-center">Esta certificación se cursa vía Zoom en tiempo real.</p>}
          </div>
          <CoursesFeatures features={features} />
          <Grid
            item
            xs={12}
            className="gridCertificaciones mb-5 justify-content-center align-items-center"
          >
            <Grid item xs={12} className="px-3 px-xl-5 mb-5">
              <GridCourses mode="live" location={location} />
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Footer />
    </div>
  );
};

export default LiveCourses;
